import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";


function QF_ML()
{
    return (
        <div>
            <Helmet>
                <title>Crypto trading ML project | QF | Lucas RODRIGUEZ</title>
            </Helmet>
            <p className="small"><i className="fa fa-arrow-left"></i>&nbsp; <NavLink to="/qf">Go back to M2QF home</NavLink></p>

            <h2>ML/DL for finance - Crypto trading project </h2>

            <p>
                <i>
                    This academic project aims at studying and implementing a crytocurrency trading strategy using machine & deep learning (incremental learning on huge time-series datasets).
                    One applies the strategy on BTC (Bitcoin) case, then, thanks to transfer learning, extends the knowledge over ETH, DOGE datasets.
                </i>
            </p>

            <hr class="col-3 col-md-4 mb-4" />

            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/cryptotrading" target="_BLANK" className="btn btn-dark">GitHub repository</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/cryptotrading/raw/main/docs/report.pdf" target="_BLANK" className="btn btn-warning">Report (PDF)</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/cryptotrading/raw/main/docs/slides.pdf" target="_BLANK" className="btn btn-warning">Slides (PDF)</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/cryptotrading/raw/main/docs/scoping_note_1.pdf" target="_BLANK" className="btn btn-warning">Scoping note 1 (PDF)</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/cryptotrading/raw/main/docs/scoping_note_2.pdf" target="_BLANK" className="btn btn-warning">Scoping note 2 (PDF)</a> <br /><br />
            <a style={{ width: "200px" }} href="https://github.com/lcsrodriguez/cryptotrading/raw/main/docs/gantt.pdf" target="_BLANK" className="btn btn-warning">Gantt chart (PDF)</a> <br /><br />


            <p className="text-muted small">
                <b>Authors</b>: Arian NAJAFY ABRANDABADY, Lucas RODRIGUEZ, Bastien TRIDON
            </p>
            <hr class="col-3 col-md-4 mb-4" />
            <p className="text-muted small">
                Work under license
            </p>
        </div >
    );
}

export default QF_ML;